import React,{Component} from 'react';
import SelectLanguage from '../Common/SelectLanguage';
import Moment from 'react-moment';
import i18n from "../../i18n";
import {withTranslation } from 'react-i18next';
import {connect} from "react-redux";

class Footer extends Component{


    render(){
        if(this.props.locale && this.props.locale !== 'en'){
            switch(this.props.locale){
                case 'ar' : this.termsOfUseUrl = this.props.getGoUrls.termsOfUseUrl + "_mena_ar" ;
                            this.privacyUrl = this.props.getGoUrls.privacyUrl + "_mena_ar" ;
                            this.cookiesUrl = this.props.getGoUrls.cookiesUrl + "_mena_ar" ;
                            break;
                case 'he' : this.termsOfUseUrl = this.props.getGoUrls.termsOfUseUrl + "_il_he" ;
                            this.privacyUrl = this.props.getGoUrls.privacyUrl + "_il_he" ;
                            this.cookiesUrl = this.props.getGoUrls.cookiesUrl + "_il_he" ;
                            break;
                case 'et' : this.termsOfUseUrl = this.props.getGoUrls.termsOfUseUrl + "_ee" ;
                            this.privacyUrl = this.props.getGoUrls.privacyUrl + "_ee" ;
                            this.cookiesUrl = this.props.getGoUrls.cookiesUrl + "_ee" ;
                            break;
                case 'sl' : this.termsOfUseUrl = this.props.getGoUrls.termsOfUseUrl + "_si" ;
                            this.privacyUrl = this.props.getGoUrls.privacyUrl + "_si" ;
                            this.cookiesUrl = this.props.getGoUrls.cookiesUrl + "_si" ;
                            break;
                default :   this.termsOfUseUrl = this.props.getGoUrls.termsOfUseUrl + "_" + this.props.locale;
                            this.privacyUrl = this.props.getGoUrls.privacyUrl + "_" + this.props.locale;
                            this.cookiesUrl = this.props.getGoUrls.cookiesUrl + "_" + this.props.locale;
                            break;
            }
        }
        else{
            this.termsOfUseUrl = this.props.getGoUrls.termsOfUseUrl;
            this.privacyUrl = this.props.getGoUrls.privacyUrl;
            this.cookiesUrl = this.props.getGoUrls.cookiesUrl;
        }
        return(
            <footer data-am-id="footer">
                <div className="footer-info">
                    <a href={this.termsOfUseUrl} target="_blank" rel="noopener noreferrer">{i18n.t('footer.termsOfUse')}</a>
                    <a href={this.privacyUrl} target="_blank" rel="noopener noreferrer">{i18n.t('footer.privacy')}</a>
                    <a href={this.cookiesUrl} target="_blank" rel="noopener noreferrer">{i18n.t('footer.cookies')}</a>
                    <a href="http://info.evidon.com/pub_info/1413?v=1" target="_blank" rel="noopener noreferrer">{i18n.t('footer.adChoices')}</a>
                    <span className="select-language-section">{i18n.t('footer.language')} <SelectLanguage/></span>
                </div>
                <div className="copy-right">
                    © <Moment format="YYYY" date={new Date()} /> {i18n.t('footer.copyRight')}
                </div>
                <div className="clear-both"></div>
            </footer>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        locale:state.LocaleReducer.value,
        getGoUrls:state.AppReducer.getGoUrls
    }
};

export default connect(mapStateToProps)(withTranslation()(Footer));
